export const environment = {
    baseUrl: '',
    controlManualUrl: 'https://ext.brunata.com/extranet-control-manual/',
    env: 'production',
    host: 'https://online.brunata.com',
    minEnergi2SSOUrl: 'https://ems.enity.io/brunata/sso',
    enityEmsUrl: 'https://brunata.ems.enity.io',
    oauthClientId: '82770188-c92e-4d16-927d-a15c472eda55',
    oauthUrl: '/online-auth-webservice/v1/rest',
    keycloakResetPasswordUrl:
        'https://online.brunata.com/iam/realms/online-prod/login-actions/reset-credentials',
    brunataEnvironment: 'prod',
    tracingEndpoint: 'https://online.brunata.com/otel/api/v2/spans',
    onlineServiceUrl: '/online-webservice/v2/rest',
    production: true,
    reactOnlineUrl: 'https://online.brunata.com/react-online',
    selfServiceUrl: '/online-reporting-webservice/rest',
    visualUrl: 'https://online.brunata.com/visual/',
    webArchiveServiceUrl: '/webarchive-webservice/rest',
    featureFlagsUrl: 'https://webbill.brunata.dk/webbill-webservice/featureflags',
    webmonIframeUrl: 'https://online.brunata.com',
    rollbarToken: '0b684a6a0e4e4a6cbf52055c3e821497',
    rollbarEnabled: true,
};
